export default (renderingItem) => {
    renderingItem.data.text = renderingItem.data.text.replace("crap", "****");
};